// extracted by mini-css-extract-plugin
export default {"SendMessageChat":"SendMessageChat_SendMessageChat__1DoV6","notConnected":"SendMessageChat_notConnected__R-eZi","buttonNotConnected":"SendMessageChat_buttonNotConnected__lNgyG"};